import template from './wizard_finish_basic.html';

class WizardFinishBasicPageViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};
	
	close()
	{
		this.dialog.close();
	};

	back_wizard()
	{
		Grape.dialog.open('WizardDepartmentsEntry', {});
		this.dialog.close();
	};

	async finish_wizard()
	{
		let res = await Grape.fetches.patchJSON('/api/setting', { name: 'system.wizard', value: false });
		// ERROR
		if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			return;
		}
		// SUCCESS
		Grape.navigate('/employee/create');
		this.dialog.close();
	};

	async continue_advanced_setup()
	{
		let res = await Grape.fetches.patchJSON('/api/setting', { name: 'system.wizard', value: false });
		// ERRROR
		if (res.status == 'ERROR')
		{
			Grape.alert_api_error(res);
			return;
		}
		// SUCCESS
		Grape.navigate('/wizard/what_todo_next');
		this.dialog.close();
	};
};

class WizardFinishBasicPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardFinishBasicPageViewModel(this);

		$.patchJSON = function(url, data, callback) {
			$.ajax({
				url: url,
				type: 'PATCH',
				contentType: 'application/json',
				data: JSON.stringify(data),
				success: callback,
				error: () => {}
			});
		};
	};
};

export default {
	name: 'WizardFinishBasic',
	dialog_class: WizardFinishBasicPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_finish_basic',
	provider: 'ps'
};
